(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxValidateWizard', {
		bindings: {
			sourceState: '@',
			isValid: '=valid',
			message: '@',
			wizard: '=?',
		},
		controller: MxValidateWizardCtrl,
		controllerAs: 'vm',
	});

	MxValidateWizardCtrl.$inject = ['mx.shell.EventService', '$scope'];

	function MxValidateWizardCtrl(eventService, $scope) {
		var vm = this;
		var off = null;

		vm.$onInit = function () {
			if (vm.sourceState !== undefined && vm.sourceState !== mx.SolutionBuilderAgent.SourceLoadingStatus.NOT_SET.toString()) {
				off = $scope.$watch('vm.sourceState', function () {
					if (vm.sourceState === mx.SolutionBuilderAgent.SourceLoadingStatus.LOADED.toString()) {
						validate();
					} else if (vm.sourceState === mx.SolutionBuilderAgent.SourceLoadingStatus.REJECTED.toString()) {
						vm.isValid = false;
						vm.message = '';
						validate();
					}
				});
			} else {
				validate();
			}
		};

		return vm;

		function validate() {
			eventService.dispatchEvent(
				mx.shell.EventCodes.ToggleWizardEnabled,
				{
					enabled: vm.isValid,
					message: vm.message,
					wizard: vm.wizard,
				},
				$scope
			);
			if (typeof off === 'function') {
				off();
			}
		}
	}
})();
